export default __webpack_public_path__ + "static/media/bg.d2171afb.svg";